import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import localforage from 'localforage';
import favouritesReducer from '../react/reducers/favouritesReducer';

const combinedReducer = combineReducers({
  favourites: favouritesReducer,
});

const rootReducer = (state, action) => combinedReducer(state, action);

/**
 * Persist the redux state to localstorage.
 * Using localforage instead of localstorage.
 * In devtools its under Application > indexedDB > localforage.
 * Add reducers that you need to be persisted to the whitelist.
 * We will need to remove the old function to persist user to localstorage.
 */

const persistConfig = {
  key: 'root',
  storage: localforage,
  whitelist: ['favourites'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
